import { TextBox } from '@apply/components';
import { usePaymentStore } from '../../../../../state/paymentStore';

export const Address2: React.FC = () => {
    const address2 = usePaymentStore((s) => s.address2);
    const set_address2 = usePaymentStore((s) => s.set_address2);

    return (
        <TextBox
            value={address2}
            onChange={(value) => set_address2(value)}
            label='Apt # / Suite'
            required={true}
        />
    );
};
